import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesContext = /*#__PURE__*/createContext(undefined);
export default function PropertiesProvider({
  children,
  propertyOverride,
  sortPropertyOverride,
  typeDefinitionOverride
}) {
  const value = useMemo(() => ({
    propertyOverride,
    typeDefinitionOverride,
    sortPropertyOverride
  }), [propertyOverride, sortPropertyOverride, typeDefinitionOverride]);
  return /*#__PURE__*/_jsx(PropertiesContext.Provider, {
    value: value,
    children: children
  });
}
export function useProperties() {
  const context = useContext(PropertiesContext);
  if (context === undefined) {
    throw new Error('useProperties must be used within a PropertiesProvider');
  }
  return context;
}